<app-base-template (modal)="openModal(content)" (searchmodal) = "searchModal()"(dataExportToExcel)="exportToExcel()" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"[isExportDisable]="isExportDisable"[showExportBtn]="showExportBtn" [showSearch]="showSearch" [dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Add followup</div>

  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelected"
              (change)="onTicketChange($event.target.selectedIndex)">
        <option *ngFor="let ticket of tickets" [value]="ticket.id">{{ticket.name}}</option>
      </select>

      <div class="warning-msg">
        *This field is mandatory
        </div>
    
    </div>
   
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="categorySelected"
              (change)="onCategoryChange($event.target.selectedIndex)">
        <option *ngFor="let category of categories" [value]="category.id">{{category.name}}</option>
      </select>

      <div class="warning-msg">
        *This field is mandatory
        </div>
    </div>
 

    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="prioritySelected"
              (change)="onPriorityChange($event.target.selectedIndex)">
        <option *ngFor="let priority of priorities" [value]="priority.id">{{priority.name}}</option>
      </select>
      <div class="warning-msg">
        *This field is mandatory
        </div>
    </div>
   

    <div class="form-group"  *ngIf = isShow>
        <input type="text" class="form-control radius-0 font-13" [(ngModel)]="psno" placeholder="Ps No">
    </div>

    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="username" placeholder="Value">
      <div class="warning-msg">
        *This field is mandatory
        </div>
  
    </div>
   
    <div class="form-group" *ngIf = isShow>
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="phoneno" placeholder="Phone No">
    </div>

    <div class="form-group" *ngIf = isShow>
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="email" placeholder="Email">
    </div>
  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>



<ng-template #scarch_content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Search</div>

  </div>
  <div class="modal-body">
      <div class="form-group mar_top">
          <input type="text" class="form-control radius-0 font-13" placeholder=" Enter Category Name"
                 [(ngModel)]="categrySelected" [formControl]="searchData">
      </div>
  </div>
  <div class="modal-footer pad-8">
          <button type="button" class="btn btn-success float-right radius-0" (click)="search()">search</button>
          <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>

  </ng-template>
<notifier-container></notifier-container>
